import { ChangeEvent, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { FieldLayout, Fieldset, FormField, Textarea } from '@anwb/poncho/components/forms';
import Panel from '@anwb/poncho/components/panel';
import { setRemarksAction } from 'store/actions';
import { remarksSelector } from 'store/selectors';
import { trackEvent } from 'utils/trackEvent';

import { StyledTypography } from './styles/fieldset-caption.styled';

export const Remarks = () => {
	const remarksValueFromStore = useSelector(remarksSelector);

	const [remarks, setRemarks] = useState(remarksValueFromStore);
	const dispatch = useDispatch();

	const handleTextareaChange: React.ChangeEventHandler<HTMLTextAreaElement> = (event) => {
		const { value } = event.target;
		setRemarks(value);
		dispatch(setRemarksAction(value));
	};

	const handleGaEvent = (event: ChangeEvent<HTMLTextAreaElement>) => {
		const value = event?.target?.value || '';
		if (value) {
			trackEvent({
				event: 'user_interaction',
				type: 'form',
				component: 'form-field',
				field: 'remarks',
				action: 'change',
				category: 'persoonlijke-gegevens',
				status: 'valid',
			});
		}
	};

	return (
		<Panel hasOuterSpacing={false}>
			<Panel.Content>
				<Fieldset
					legend={
						<StyledTypography variant="component-title" tagName="h2">
							Extra opmerkingen (optioneel)
						</StyledTypography>
					}
				>
					<FieldLayout>
						<FormField size="l">
							<Textarea
								value={remarks}
								reference="remarks"
								name="reference"
								data-test="remarks-textarea"
								maxLength={300}
								onChange={handleTextareaChange}
								aria-label="Extra opmerkingen (optioneel)"
								onBlur={handleGaEvent}
							/>
						</FormField>
					</FieldLayout>
				</Fieldset>
			</Panel.Content>
		</Panel>
	);
};
